module.exports = __webpack_public_path__ + "static/media/django.23126631.svg";